export class FeeCalculatingError extends Error {
    public readonly name: string;
    public readonly stack: string;

    constructor(message: string, stack: string = '') {
        super(message);
        this.name = 'FeeServiceFailed';
        this.stack = stack;
        Object.setPrototypeOf(this, FeeCalculatingError.prototype);
    }
}
